/**
 * Rich text.
 *
 * A structural block/span model rather than an HTML string. Three reasons, all of which bite
 * later if you pick HTML now: it can be diffed and merged, it cannot carry script or styling
 * that escapes the app, and it can be rendered to SVG and PDF — which the export requirements
 * demand, and which HTML-in-a-canvas cannot do.
 *
 * `Node.plainText` is derived from this by `toPlainText`, never typed separately. Search,
 * embeddings, accessibility labels and export all read `plainText`, so a copy that can drift
 * from the rich text would corrupt all four at once.
 */
export const EMPTY_RICH_TEXT = { blocks: [] };
/** A single-paragraph document — what typing a node label produces. */
export function richTextFromPlain(text) {
    if (text.length === 0)
        return EMPTY_RICH_TEXT;
    return {
        blocks: text.split('\n').map((line) => ({
            kind: 'paragraph',
            spans: line.length === 0 ? [] : [{ text: line }],
        })),
    };
}
/**
 * The canonical plain-text projection.
 *
 * Blocks join with newlines; spans within a block join with nothing, because a span boundary is
 * a formatting change, not a word boundary — inserting a space there would corrupt every search
 * result for a word that happens to be half bold.
 */
export function toPlainText(rich) {
    return rich.blocks.map((block) => block.spans.map((span) => span.text).join('')).join('\n');
}
export function isEmpty(rich) {
    return toPlainText(rich).trim().length === 0;
}
/** Character count, for the description limits the AI panel enforces. */
export function textLength(rich) {
    return toPlainText(rich).length;
}
//# sourceMappingURL=richText.js.map